<template>
	<div>
		<div _flex="~ items-center" style="height: calc(100vh)" _w="100%">
			<div class="w-basis-1/2" _flex="~ row-reverse">
				<img :src="BannerImg" width="95%" />
			</div>
			<div _flex="1 ~ justify-center">
				<div _flex="~ col items-center justify-center">
          <h2 class="title">智能化课件后台管理系统</h2>
          <login />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Login from './Login.vue'
import PublicNotice from './PublicNotice.vue'
const BannerImg = require('@/assets/test_client/LoginImg.png')
const LoginImg = require('@/assets/test_client/Logo.png')
export default {
	data() {
		return {
			BannerImg,
			LoginImg,
			adList: [],
			username: '',
			password: '',
			type: '',
			id: '',
			avatar: ''
		}
	},
	components: {
		Login,
		PublicNotice
	},
	methods: {
		getUrlParam(name, url = location.href) {
			let reg = new RegExp('(^|&)' + name + '=([^&#]*)(&|#|$)', 'i')
			let r = (url.split('?')[1] || window.location.search.substr(1)).match(reg) // 获取地址"?"符后的字符串并正则匹配
			let context = ''
			if (r != null) {
				context = r[2]
			}
			reg = null
			r = null
			return context == null || context === '' || context === 'undefined' ? '' : decodeURIComponent(context)
		}
	},
	async created() {
		this.username = this.getUrlParam('username')
		this.password = this.getUrlParam('password')
		this.type = this.getUrlParam('type')
		this.id = this.getUrlParam('id')
		this.avatar = this.getUrlParam('avatar')
		var res = await this.$api.ad.list({
			filterBy: {
				type: 1
			},
			sortBy: {
				sort_order: 'desc'
			},
			paginate: {
				size: 4
			}
		})

		this.adList = res.data
	}
}
</script>
<style lang="scss" scoped>
@import '@/styles/settings.scss';
.flex {
	//height: 100%;
	display: flex;
	justify-content: space-between;
	margin-top: 40px;
}
.title {
	margin: 0;
	font-size: 36px;
	font-family: PingFang SC-Heavy, PingFang SC;
	font-weight: 800;
	color: #585858;
	//color: rgba(48, 49, 51, 1);
	line-height: 48px;
	margin-bottom: 30px;
	-webkit-background-clip: text;
}
.carousel-box {
	width: 936.31px;
	border-radius: 8px;
	margin-left: 28px;
	.carousel {
		border-radius: 8px;
	}
	img {
		width: 100%;
		height: 713px;
		object-fit: cover;
		object-position: center center;
	}
}
// .login-box {
// 	width: $mainWidth - 1406px -10px;
// 	margin-right: 200px;
// }
.notice-box {
	margin-top: 10px;
}
#download {
	position: fixed;
	right: 0;
	bottom: 30%;
	background-color: white;
	padding: 10px;

	img {
		width: 100px;
	}

	p {
		font-size: 0.9rem;
		text-align: center;
	}
}
</style>
